(function () {
    'use strict';
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    if (!toggle) return;

    var nav = document.querySelector('.site-nav');

    function openMenu() {
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('mobile-menu-open');
    }

    function closeMenu() {
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mobile-menu-open');
    }

    function isOpen() {
        return document.body.classList.contains('mobile-menu-open');
    }

    // Toggle on hamburger click
    toggle.addEventListener('click', function () {
        if (isOpen()) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) {
            closeMenu();
        }
    });

    // Close menu when clicking a nav link
    document.querySelectorAll('.site-nav .nav a').forEach(function (link) {
        link.addEventListener('click', function () {
            if (isOpen()) {
                closeMenu();
            }
        });
    });

    // Close menu when clicking outside nav and toggle button
    document.addEventListener('click', function (e) {
        if (!isOpen()) return;
        if (nav && nav.contains(e.target)) return;
        if (toggle.contains(e.target)) return;
        closeMenu();
    });

    // Highlight active nav link based on current path
    var path = window.location.pathname;
    document.querySelectorAll('.site-nav .nav a').forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href) return;
        try {
            var linkPath = new URL(href, window.location.origin).pathname;
            if (linkPath === '/' && path === '/') {
                link.classList.add('nav-current');
            } else if (linkPath !== '/' && path.indexOf(linkPath) === 0) {
                link.classList.add('nav-current');
            }
        } catch (e) { /* skip invalid URLs */ }
    });
})();
